import React from 'react';
import PropTypes from 'prop-types';
import AgentCard from '@/components/AgentCard';

function AgentTile({ agent, onPress, onUseAgent, isLoading, compact }) {
  return (
    <AgentCard
      agent={agent}
      onPress={onPress}
      onUseAgent={onUseAgent || onPress}
      isLoading={isLoading}
      compact={compact}
    />
  );
}

AgentTile.propTypes = {
  agent: PropTypes.object,
  onPress: PropTypes.func,
  onUseAgent: PropTypes.func,
  isLoading: PropTypes.bool,
  compact: PropTypes.bool,
};

export default React.memo(AgentTile);
